<template>
    <Link :href="'/evento/'+item.slug" class="tarjeta-evento-sidebar">
        <div class="tarjeta-evento-sidebar__img-wrapper">
            <div class="tarjeta-evento-sidebar__img" :style="'background-image: url(\''+item.portada.small+'\');'"></div>
        </div>
        <div class="tarjeta-evento-sidebar__color azul">
            <div class="tarjeta-evento-sidebar__info">
            <h6>{{ item.nombre }}</h6>
            <div class="tarjeta-evento-sidebar__fecha">
                <div v-if="item.fecha_desde!=item.fecha_hasta">
                    <span>{{ $filters.getDayMonthDate(item.fecha_desde) }}</span><br/> al
                    <span>{{ $filters.getDayMonthDate(item.fecha_hasta) }}</span>
                </div>
                <div v-else>
                    <span>{{ $filters.getDayMonthDate(item.fecha_desde) }}</span>
                </div>
            </div>
            </div>
        </div>
    </Link>
</template>
<script>
import { Link } from '@inertiajs/inertia-vue3'
export default {
    props: {
        item: Object,
    },
    components: { Link }
}
</script>
<style>
h6 {
    max-height: initial;
    font-size: 18px;
    margin-top: 0;
    line-height: 1.3em;
    margin-bottom: 0;
}
</style>
